/**
 * Where the Firm Onboarding page and its tabs live (#6261).
 *
 * The organization's defaults for automatic proposal creation were the side navigation's
 * "Proposal Templates" at `/client-proposal-templates`, and then a page under the Proposals page's
 * Templates tab. They are neither: they say what a firm's draft is built from when it finishes
 * onboarding, so they are a tab of the page that watches the onboarding. The old address redirects.
 */
export const FIRM_ONBOARDING_PATH = "/firm-onboarding";
export const FIRM_ONBOARDING_DEFAULTS_PATH = "/firm-onboarding/defaults";
export const FIRM_ONBOARDING_DEFAULTS_LABEL = "Firm Onboarding Defaults";

export enum FirmOnboardingTab {
  Firms = "firms",
  Defaults = "defaults",
}

export function firmOnboardingTabPath(tab: FirmOnboardingTab): string {
  return tab === FirmOnboardingTab.Defaults ? FIRM_ONBOARDING_DEFAULTS_PATH : FIRM_ONBOARDING_PATH;
}
